export enum BoothStatusType {
  B0100001 = '신청서 접수 완료',
  B0100002 = '수정 요청',
  B0100003 = '결제 대기 중',
  B0100004 = '참가 확정',
  B0100005 = '환불 완료',
}

export enum CircleStatusType {
  B0100001 = 'REVIEW',
  B0100002 = 'MODIFY',
  B0100003 = 'WAIT_PAY',
  B0100004 = 'COMPLETE',
  B0100005 = 'REFUND',
  B0100006 = 'CANCLE',
  B0100007 = 'PAY_PROCESSING',
  B0100008 = 'REFUND_REQUEST',
  B0100009 = 'PAY_LIMIT_EXCEED',
}

export const circleStatusMap = (status: string) => {
  if (status === 'REVIEW') {
    return '신청서 접수 완료'
  } else if (status === 'MODIFY') {
    return '수정 요청'
  } else if (status === 'WAIT_PAY') {
    return '결제 대기중'
  } else if (status === 'COMPLETE') {
    return '참가 확정'
  } else if (status === 'REFUND') {
    return '환불 완료'
  } else if (status === 'CANCLE') {
    return '취소 완료'
  } else if (status === 'PAY_PROCESSING') {
    return '결제 진행중'
  } else if (status === 'REFUND_REQUEST') {
    return '환불 요청'
  } else if (status === 'PAY_LIMIT_EXCEED') {
    return '입금 기한 초과'
  }
}

export enum DateType {
  E0300001 = '토요일',
  E0300002 = '일요일',
  E0300003 = '토요일, 일요일(양일)',
}

export enum BoothType {
  B0200001 = '초소형 부스 (책상 1개, 디스플레이 책상위 90cm 이하)',
  B0200002 = '소형 부스 (책상 1개 사용)',
  B0200003 = '중형 부스 (책상 2개 사용)',
  B0200004 = '대형 부스 (책상 3개 사용)',
  B0200005 = '초대형 서클 업그레이드 A형 (책상 2+1개)',
  B0200006 = '초대형 서클 업그레이드 B형 (책상 3+1개)',
  B0200007 = '초대형 서클 업그레이드 C형 (책상 4+1개)',
}

export enum ZoneType {
  B0300001 = '종합 서클 (특별존 미참여 일반 서클)',
  B0300002 = '크리에스타 (Creastar) - 1차 창작 전용 특별존',
  B0300003 = '보카스타 (VOCASTAR) - 보컬 캐릭터즈 특별존',
  B0300004 = '버츄올스타 (VirtuAllStar) - 버츄얼 스트리머 특별존',
  B0300005 = '어른의 특별존 - 성인등급 작품 취급 특별존',
}

export enum SizeType {
  B0400001 = '1~2인',
  B0400002 = '3~5인',
  B0400003 = '6~9인',
  B0400004 = '10인 이상',
}

export enum ComplexityType {
  B0500001 = '해당없음',
  B0500002 = '10인~30인 정도 대기열 발생 경험이 있음',
  B0500003 = '30인 초과 긴 대기열 발생 경험이 있음',
}

export enum ExpType {
  B0600001 = '해당없음',
  B0600002 = '국내 1~4번 참가',
  B0600003 = '국내 5번 이상 참가',
  B0600004 = '국내 5번 이상 및 해외 행사 참가 경험 있음',
}

export enum GoodsType {
  B0700001 = '일러스트북',
  B0700002 = '만화(동인지)',
  B0700003 = '엽서, 카드택 등 소형 지류 굿즈',
  B0700004 = '족자봉, 브로마이드 등 대형 평면 굿즈',
  B0700005 = '아크릴 스탠드, 참 등 준 입체 굿즈',
  B0700006 = '쿠션, 인형 등 말랑 입체 굿즈',
  B0700007 = '기타 수공예품',
  B0700008 = '음반, 레코드, 음악 카드 등 음원 기반 굿즈',
  B0700009 = '게임 및 소프트웨어',
}

export enum GenreType {
  B0800001 = '여성캐릭터 중심 1차 창작',
  B0800002 = '여성캐릭터 중심(게임 2차 창작)',
  B0800003 = '여성캐릭터 중심(애니메이션, 만화, 웹툰, 소설 2차 창작)',
  B0800004 = '여성캐릭터 중심(버튜버 및 기타 2차 창작)',
  B0800005 = '남성캐릭터 중심(게임 2차 창작)',
  B0800006 = '남성캐릭터 중심(애니메이션, 만화, 웹툰, 소설 2차 창작)',
  B0800007 = '남성캐릭터 중심(버튜버 및 기타 2차 창작)',
}

export type Image = {
  id: number
  parent_table_key?: number
  original_name?: string
  url: string
}

export type Goods = {
  id: number
  parent_table_key?: number
  original_name?: string
  url: string
}

export type UserBoothApplication = {
  id?: string
  booth_name?: string
  user_name?: string
  user_email?: string
  user_mobile?: string
  user_nickname?: string
  size_type?: string
  complexity_type?: string
  exp_type?: string
  goods_type?: string
  genre_type?: string
  etc?: string
  tag?: string
  image?: number
  goods_list?: Goods[]
  date_type?: keyof typeof DateType
  booth_type?: keyof typeof BoothType
  booth_option_type?: string
  zone_type?: keyof typeof ZoneType
  near_booth?: string
  homepage?: string
  introduce?: string
  is_option?: string
}

export type Date = {
  code: string
  name: string
  description: string
  sort: number
  category_code: string
  id: number
  category_id: number
}

export type Booth = {
  code: string
  name: string
  description: string
  sort: number
  category_code: string
  id: number
  sorting: number
  category_id: number
  event_id: number
  common_code: string
  booth_amount: number
  limit_count: number
  created_at: string
  updated_at: string
  delete_yn: string
  is_option: string
}

export type BoothApplication = {
  id: number
  event_id: number
  round: number
  date_type: string
  booth_type: string
  zone_type: string
  size_type: string
  complexity_type: string
  exp_type: string
  goods_type: string
  genre_type: string
  start_at: string
  end_at: string
  created_at: string
  updated_at: string
  delete_yn: string
  caution: string
  prohibit: string
  period: string
  date_type_list: Date[]
  booth_type_list: Booth[]
  zone_type_list: ItemType[]
  size_type_list: ItemType[]
  complexity_type_list: ItemType[]
  exp_type_list: ItemType[]
  goods_type_list: ItemType[]
  genre_type_list: ItemType[]
}

export type ItemType = {
  code: string
  name: string
  description: string
  sort: number
  category_code: string
  id: number
  sorting: number
  category_id: number
}

export type Ticket = {
  id: number
  ticket_type: string
  user_id: number
  event_id: number
  event_name: string
  event_date: string
  ticket_id: number
  event_ticket_id: number
  payment_id: number
  option_1: number
  user_quantity: number
  ticket_code: string
  admission_type: string
  admission_day: string
  admission_type_desc: string
  admission_day_desc: string
  used_at: string
  qr_code: string
}

export type PaymentInfo = {
  id: number
  event_id: number
  user_id: number
  type: string
  divide: string
  order_id: number
  order_code: string
  goods_id: number
  quantity: number
  option_1_quantity: number
  amount: number
  discount_amount: number
  option_1_amount: number
  mid: string
  currency: string
  method: string
  total_amount: number
  status: string
  requested_at: string
  approved_at: string
  approve_no: string
  payment_key: string
  payment_type: string
  payment_method: string
  error_code: string
  success: boolean
}

export type PageInfo = {
  page: number
  row_per_page: number
  total_count: number
  max_page: number
  keyword: string
  category: string
  sort: string
  search: {}
}

export type EventInfo = {
  id: number
  round: number
  name: string
  status: string
  place: string
  start_date: string
  end_date: string
  show_date: string
}
